import dayjs from 'dayjs';
import { environment } from '@/config/environment';
import { appInsights } from './appInsights';

const level = environment.appInsights.loggingLevel;

function timestamp() {
  return dayjs().format('YYYY-MM-DD HH:mm:ss.SSS');
}

export const logger = {
  log(message: string, ...args: unknown[]) {
    if (level >= 2) console.log(`[${timestamp()}] ${message}`, ...args);
  },
  warn(message: string, ...args: unknown[]) {
    if (level >= 1) console.warn(`[${timestamp()}] WARN: ${message}`, ...args);
    appInsights.logTrace(message, 2);
  },
  error(message: string, error?: Error) {
    console.error(`[${timestamp()}] ERROR: ${message}`, error);
    if (error) appInsights.logException(error);
    else appInsights.logTrace(message, 3);
  },
  track(name: string, properties?: Record<string, string>) {
    appInsights.logEvent(name, properties);
  },
};
